export default __webpack_public_path__ + "images/54d1cfedc26fe89cd3fb549b28ce686b-thrive-congrats-es.svg";